import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// 路由
import "@/permission.js";
// 懒加载组件
import "@/config/lazy_use.js";
// 全局插件
import "@/config/global_plugin.js";
// 全局样式
import "@/styles/global.less";
// 全局指令
import "@/directives/action.js";

import "fullpage.js/vendors/scrolloverflow"; // Optional. When using scrollOverflow:true
import "fullpage.js/dist/fullpage.min.css"; // css
import VueFullPage from "vue-fullpage.js";

import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.use(VueFullPage);
Vue.use(VueQuillEditor);
// 主题色
if (process.env.VUE_APP_PROJECT_NAME === "all") {
  store.commit("SET_PRIMAY_COLOR", "#0F338D");
  // 眼科
} else if (process.env.VUE_APP_PROJECT_NAME === "eye") {
  store.commit("SET_PRIMAY_COLOR", "#234B86");
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
